export const registrationOrderBy = (competitors, orderBy) => {
  if (orderBy === 'ALPHA') {
    return [...competitors].sort((a, b) => {
      const aName = a.competitor.firstName + a.competitor.lastName
      const bName = b.competitor.firstName + b.competitor.lastName
      return aName > bName ? 1 : -1
    })
  }
  if (orderBy === 'ASSIGNED_NUMBER') {
    return [...competitors].sort((a, b) => parseInt(a.assignedNumber ?? 0) > parseInt(b.assignedNumber ?? 0) ? 1 : -1)
  }
  if (orderBy === 'DESC') return [...competitors].sort((a, b) => a.id < b.id ? 1 : -1)
  if (orderBy === 'ASC') return [...competitors].sort((a, b) => a.id > b.id ? 1 : -1)
  return [...competitors].sort((a, b) => a.club?.id > b.club?.id ? 1 : -1)
}

const SEMINAR_PARTICIPANTS_SORT_KEY = 'seminarParticipantsSortBy'

export const seminarParticipantsOrderBy = (participants, orderBy) => {
  if (orderBy === 'ALPHA') {
    return [...participants].sort((a, b) => {
      const aName = (a.member?.firstName || '') + (a.member?.lastName || '')
      const bName = (b.member?.firstName || '') + (b.member?.lastName || '')
      return aName.localeCompare(bName)
    })
  }
  if (orderBy === 'DESC') return [...participants].sort((a, b) => (a.id < b.id ? 1 : -1))
  if (orderBy === 'ASC') return [...participants].sort((a, b) => (a.id > b.id ? 1 : -1))
  if (orderBy === 'CLUB') return [...participants].sort((a, b) => (a.club?.id > b.club?.id ? 1 : -1))
  return [...participants]
}

export const getSeminarParticipantsSortBy = () =>
  (typeof localStorage !== 'undefined' && localStorage.getItem(SEMINAR_PARTICIPANTS_SORT_KEY)) || 'DESC'
